import { Trans, useTranslation } from "react-i18next";

import { Button, Link, Typography } from "@aviary";
import { BackupCode } from "@shared/components/BackupCode";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./NewBackupCodeView.styles";

const twoFactorSettingsRoutes = {
  patient: "/u/account",
  practitioner: "/o/account_settings/security",
  clerk: "/o/account_settings",
} as const;

interface Props {
  newBackupCode: string;
  redirectPath: string;
  roleType: string;
}

const NewBackupCodeView = ({ newBackupCode, redirectPath, roleType }: Props) => {
  const { t } = useTranslation();

  const navigateToRedirectPath = () => {
    window.location.assign(redirectPath);
  };

  const getAccountSettingsRoute = () => {
    switch (roleType) {
      case "Clerk":
        return twoFactorSettingsRoutes.clerk;
      case "Practitioner":
        return twoFactorSettingsRoutes.practitioner;
      case "Patient":
        return twoFactorSettingsRoutes.patient;
      default:
        return null;
    }
  };

  const renderAccountSettingsLink = () => {
    const accountSettingsRoute = getAccountSettingsRoute();

    if (accountSettingsRoute) {
      return <Link href={accountSettingsRoute}>Account settings</Link>;
    }

    return <strong>Account settings</strong>;
  };

  return (
    <div css={styles.wrapper}>
      <Typography type="h1" sizeOverride="h3">
        {t(l.signIn.backupCode)}
      </Typography>
      <Trans i18nKey={l.signIn.newBackupCodeView.subtitle}>
        <Typography isMarginless>
          Here is your new backup code. Please store it securely.
        </Typography>
        <Typography>
          You can view this again in your Fullscript
          {renderAccountSettingsLink()}.
        </Typography>
      </Trans>
      <BackupCode backupCode={newBackupCode} />
      <Button css={styles.nextButton} onClick={navigateToRedirectPath}>
        {t(l.common.Next)}
      </Button>
    </div>
  );
};

export { NewBackupCodeView, twoFactorSettingsRoutes };
